import { IMarkdownParser } from './types';

export function assignHelp(fn: IMarkdownParser) {
  Object.assign(fn, {
    help: `A markdown parser. Accepts a configuration object with the following structure: 
  
interface IMarkdownFile {
  /**
   * Cadena de caracteres de CSS
   */
  additionalStyles?: string;
  /**
   * Contenido markdown
   */
  content: string;
  /**
   * Si el template html por defecto no es suficiente, se puede optar por un
   * template a medida.
   */
  htmlTemplate?: IMarkdownHtml;
  /**
   * Título que se mostrará en el html
   */
  title: string;
}`,
  });
}
